class Prototype {

    constructor(node) {
        this.node = node;
        this.node.remove();
        this.node.removeClass('prototype');
    }

    clone() {
        return this.node.clone();
    }

    cloneInto(target) {
        let clone = this.clone();
        target.append(clone);
        return clone;
    }
}
